import styled from "@emotion/styled";
import { Box, Pagination, SelectChangeEvent, alpha } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  GrayClassAndBoardIcon,
  GrayMapIcon,
  TrashCanIcon,
  WarningIcon,
  Battery5,
  Battery4,
  Battery3,
  Battery2,
  Battery1,
  Battery0,
} from "../../assets/icons/icons";
import useGetMobility from "../../hooks/useGetMobility";
import theme from "../../theme";
import SubHeader from "./subHeader";
import MobilityDetailModal from "../../components/mobilityDetailModal";
import AlertModal from "../../components/alertModal";
import useDeleteMobility from "../../hooks/useDeleteMobility";
import { MobileInfo } from "../../types/types";
import userStorage from "../../utils/userStorage";
import { useNavigate } from "react-router-dom";
import Switch from "@mui/material/Switch";
import usePutTestMode from "../../hooks/usePutTestMode";
import BattertyDescription from "../../assets/images/BatteryDescription.png";
import Spinner from "../../components/spinner";
import { SortArrow } from "../../components/sortArrow";
import { DotLoader } from "../../components/dotLoader";
import {
  copyToClipboard,
  formatDate,
  handleClickForSort,
  isOlderThan24Hours,
  textSubstring,
} from "../../utils/util";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import { PageLayout } from "../../components/PageLayout";
import { useSnackbar } from "notistack";
import { useSystemSetting } from "../../hooks/useSystemSetting";
import { useWindowSize } from "@reactuses/core";
import { MobileMobileList } from "./mobileMobileList";
import { SrLable } from "../../components/common/SrLabel";
import { format } from "date-fns";
import MuiCheckbox from "@mui/material/Checkbox";
import usePostMobilityInstallDownload from "../../hooks/usePostMobilityInstallDownload";
import { Button } from "../../components/common/Button";
import { useI18n } from "../../locales";

const { md } = theme.screen;

export interface FetchParams {
  startDate: Date | null;
  endDate: Date | null;
  searchKey: string;
  mobFilter: number;
  eventCode: number;
  groupId: string;
}

const MobileList: React.FC<{}> = () => {
  const { t } = useI18n();
  const { enqueueSnackbar } = useSnackbar();
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const [mobFilter, setMobFilter] = useState(-1);
  const [searchKey, setSearchKey] = useState("");
  const [realMobFilter, setRealMobFilter] = useState();
  const [page, setPage] = useState(0);
  const [, setFetch] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [idx, setIdx] = useState<null | string>(null);
  const user = userStorage.get();
  const [openDelModal, setOpenDelModal] = useState(false);
  const [openToggleModal, setOpenToggleModal] = useState(false);
  const [testMode, setTestMode] = useState<0 | 1>(0);
  const [sort, setSort] = useState<string | undefined>("");
  const [pid, setPid] = useState<null | string>(null);
  const systemSetting = useSystemSetting();
  const [startDate, setStartDate] = useState<Date | null>(null);
  const [endDate, setEndDate] = useState<Date | null>(null);
  const [groupSubCode, setGroupSubCode] = useState(""); // 하위그룹코드(api용)
  const [eventCode, setEventCode] = useState(0);
  const [selectRow, setSelectRow] = useState<string>("");
  const [selectCount, setSelectCount] = useState(0);
  const [downSeq, setDownSeq] = useState<string>("");
  const [selectedSeq, setSelectedSeq] = useState(new Set());
  const [isAllCheck, setIsAllCheck] = useState<boolean>(false);
  const [allCheckPage, setAllCheckPage] = useState(new Set());

  const { data, isLoading } = useGetMobility({
    limit: 10,
    page,
    searchKey,
    mobilityCode: realMobFilter ?? -1,
    area: user?.area as string,
    sort,
    event_code: eventCode,
    ...(startDate && {
      startDate: format(new Date(startDate as Date), "yyyy-MM-dd"),
    }),
    ...(endDate && {
      endDate: format(new Date(endDate as Date), "yyyy-MM-dd"),
    }),
    ...(groupSubCode &&
      groupSubCode !== "all" && { groupId: groupSubCode }),
  });

  //설치 내역 다운
  const { mutate: postDown } =
    usePostMobilityInstallDownload();

  const startFetch = () => {
    setFetch(true);
  };

  const { mutate: patchTestMode } = usePutTestMode();

  const { mutate: deleteMobility } = useDeleteMobility();

  const handleChange = (_: React.ChangeEvent<unknown>, value: number) => {
    setPage(value - 1);
  };

  const mobHandleChange = (event: SelectChangeEvent<number>) => {
    setMobFilter(Number(event.target.value));
  };

  // const onClickBtn = (input: string) => {
  //   setSearchKey(input);
  //   setPage(0);

  // };

  const onClickBtn = ({
    startDate,
    endDate,
    searchKey,
    eventCode,
    mobFilter,
    groupId,
  }: FetchParams) => {
    setStartDate(startDate);
    setEndDate(endDate);
    setSearchKey(searchKey);
    setEventCode(eventCode);
    setMobFilter(mobFilter);
    setPage(0);
    setGroupSubCode(groupId);
  };

  const onClickTestMode = (pid: string, mode: 0 | 1) => {
    setPid(pid);
    setOpenToggleModal(true);
    setTestMode(mode);
    //patchTestMode();
  };

  const onClickToggle = () => {
    setOpenToggleModal(false);
    if (pid) {
      patchTestMode({ pid: String(pid) });
    }
  };

  const onCancelToggle = () => {
    setOpenToggleModal(false);
  };

  const onClickIcon = (seq: number) => {
    setIdx(seq.toString());
    openDetailModal();
  };

  const openDetailModal = () => {
    setOpenModal(true);
  };

  const onClickCancel = () => {
    setOpenModal(false);
  };

  const onClickDel = () => {
    setOpenDelModal(false);
    if (idx) {
      deleteMobility({
        seq: Number(idx),
      });
    }
  };

  const onCancelDel = () => {
    setOpenDelModal(false);
  };

  const onClickTrashIcon = (el: MobileInfo) => {
    setIdx(el.seq.toString());
    setOpenDelModal(true);
  };

  const onClickMapIcon = (el: MobileInfo) => {
    navigate(`/`/*`/control`*/, {
      state: {
        from: "mobileList",
        data: el,
      },
    });
  };

  // 기기정보 상세보기 모달 닫기
  const onCloseDetailModal = () => {
    setOpenModal(false);
  };

  const onClickCopy = (text: string) => {
    copyToClipboard(text);
    enqueueSnackbar(t.mobileList.clipboardCopied, {
      variant: "success",
    });
  };

  const makeTableHeadList = (id: string, title: string, width: number) => {
    return (
      <TableHeaderList
        onClick={() => {
          handleClickForSort(id, setSort);
        }}
        width={width}
        disabled={data?.list.length === 0}
      >
        {title} <SortArrow id={id} state={sort} />
      </TableHeaderList>
    );
  };

  const handleCheckClick = (seq: number) => {
    const newSelectedSeq = new Set(selectedSeq);        
        if (newSelectedSeq.has(seq)) {
          newSelectedSeq.delete(seq);
        } else {
          newSelectedSeq.add(seq);
        }    
    setSelectedSeq(newSelectedSeq);
    if (selectRow==="") {
      setSelectRow(seq+"");
    } else {
      
      if (selectRow.split(',').map(item => item.trim()).some(item => item === seq.toString())) {
        setSelectRow(selectRow.split(',').filter(item => item.trim() !== seq.toString().trim()).join(',')); 
      } else {
        setSelectRow(selectRow+","+seq);
      }
    }
  };

  useEffect(() => {
    setSelectCount(selectRow===""?0:selectRow.split(',').length);
    setDownSeq(selectRow);
    //onClickStatBtn(runStatClick);
    
    const selectRowArray = selectRow.split(',').map(item => item.trim());
    if(data?.list.every(item => selectRowArray.includes(item.seq.toString()))) {
      const newAllCheckPage = new Set(allCheckPage);
      newAllCheckPage.add(page);
      setAllCheckPage(newAllCheckPage);
      setIsAllCheck(true);
    } else {
      const newAllCheckPage = new Set(allCheckPage);
      newAllCheckPage.delete(page);
      setAllCheckPage(newAllCheckPage);
      setIsAllCheck(false);
    }
  }, [selectRow,setDownSeq]);

  const onClickDown = () => {
    postDown(
      {
        seq: downSeq
      },
      {
        onSuccess: async (data) => {
          // 만약 data가 없다면 에러 메시지를 표시하고 종료
          if (!data.data)
            enqueueSnackbar(t.mobileList.noDownloadAvailable, {
              variant: "error",
            });

          // Blob 데이터를 받아서 Blob URL을 생성 (파일을 다운로드할 수 있는 URL)
          const url = window.URL.createObjectURL(data.data);
          // <a> 태그를 동적으로 생성하여 다운로드 링크를 만듦
          const a = document.createElement("a");
          a.href = url;

          // content-disposition 헤더에서 파일명 추출
          const fileNameMatch = data.headers["content-disposition"]?.match(
            /filename\*=UTF-8''(.+)/
          );
          // 기본 파일명 설정
          //let fileName = "default_filename.xlsx"; // 기본 파일 이름
          let fileName = "install_list.xlsx"; // 기본 파일 이름
          if (fileNameMatch && fileNameMatch[1]) {
            // 추출된 URL 인코딩된 파일명을 decodeURIComponent로 디코딩
            fileName = decodeURIComponent(fileNameMatch[1]);
          }
          a.download = fileName ? fileName : `download_file`;

          document.body.appendChild(a);
          a.click();

          // Blob URL을 해제하여 메모리에서 정리
          setTimeout(() => {
            window.URL.revokeObjectURL(url);
          }, 1000);
          a.remove();

          // 다운로드 성공 메시지를 로그인 유저에게 표시
          enqueueSnackbar(t.mobileList.downloadSuccess, {
            variant: "success",
          });
          return data;
        },
      }
    );
  };

  const handleAllCheckClick = () => {
    if(isAllCheck) {
      const selectRowArray = selectRow.split(',').map(item => item.trim());
      if(data?.list.every(item => selectRowArray.includes(item.seq.toString()))) {
        const newSelectedSeq = new Set(selectedSeq);
        data?.list.forEach(value => newSelectedSeq.delete(value.seq));
        setSelectedSeq(newSelectedSeq);
        setIsAllCheck(false);
  
        if (!data?.list || !selectRow) return;
        const seqsToRemove = new Set(data.list.map(el => el.seq.toString()));
  
        const newSelectRow = selectRow
          .split(',')
          .map(item => item.trim())
          .filter(item => item !== '' && !seqsToRemove.has(item))
          .join(',');
          
        setSelectRow(newSelectRow);
        if (allCheckPage.has(page)) {
          const newAllCheckPage = new Set(allCheckPage);
          newAllCheckPage.delete(page);
          setAllCheckPage(newAllCheckPage);
        }
      }
    } else {
      setSelectedSeq(new Set(data?.list.map(item => item.seq)));
      if(selectRow==="") {
        setSelectRow(Array.from(new Set(data?.list.map(item => item.seq))).join(',')); 
      } else {
        //setSelectRow(selectRow+","+Array.from(new Set(data?.list.map(item => item.seq))).join(',')); 
        setSelectRow(prev => [...new Set([...(prev ? prev.split(',') : []), ...(data?.list.map(item => item.seq.toString()) || [])])].join(','));
      }
      setIsAllCheck(true);
      if (!allCheckPage.has(page)) {
        const newAllCheckPage = new Set(allCheckPage);
        newAllCheckPage.add(page);
        setAllCheckPage(newAllCheckPage);
      }
    }

    // if (!allCheckPage.has(page)) {
    //   setSelectedSeq(new Set(data?.list.map(item => item.seq)));
    //   if(selectRow==="") {
    //     setSelectRow(Array.from(new Set(data?.list.map(item => item.seq))).join(',')); 
    //   } else {
    //     //setSelectRow(selectRow+","+Array.from(new Set(data?.list.map(item => item.seq))).join(',')); 
    //     setSelectRow(prev => [...new Set([...(prev ? prev.split(',') : []), ...(data?.list.map(item => item.seq.toString()) || [])])].join(','));
    //   }
    //   setIsAllCheck(true);
    //   if (!allCheckPage.has(page)) {
    //     const newAllCheckPage = new Set(allCheckPage);
    //     newAllCheckPage.add(page);
    //     setAllCheckPage(newAllCheckPage);
    //   }
    // } else {
    //   const newSelectedSeq = new Set(selectedSeq);
    //   data?.list.forEach(value => newSelectedSeq.delete(value.seq));
    //   setSelectedSeq(newSelectedSeq);
    //   setIsAllCheck(false);

    //   if (!data?.list || !selectRow) return;
    //   const seqsToRemove = new Set(data.list.map(el => el.seq.toString()));

    //   const newSelectRow = selectRow
    //     .split(',')
    //     .map(item => item.trim())
    //     .filter(item => item !== '' && !seqsToRemove.has(item))
    //     .join(',');
        
    //   setSelectRow(newSelectRow);
    //   if (allCheckPage.has(page)) {
    //     const newAllCheckPage = new Set(allCheckPage);
    //     newAllCheckPage.delete(page);
    //     setAllCheckPage(newAllCheckPage);
    //   }
    //   // data?.list.map((el) => {
    //   //   if (selectRow.includes(el.seq.toString())) {
    //   //     setSelectRow(selectRow.split(',').filter(item => item.trim() !== el.seq.toString().trim()).join(',')); 
    //   //   }
    //   // });
    // }
  };

  useEffect(() => {
    if (allCheckPage.has(page)) {
      setIsAllCheck(true);
    } else {
      setIsAllCheck(false);
    }
  },[data, allCheckPage]);

  // console.log(data?.list);

  return (
    <PageLayout
      subHeader={
        width > md && (
          <SubHeader
            startFetch={startFetch}
            mobFilter={mobFilter}
            mobHandleChange={mobHandleChange}
            onClickBtn={onClickBtn}
            setRealMobFilter={setRealMobFilter}
            systemSetting={systemSetting("mobility")}
          />
        )
      }
      bodyPaddingBottom={width > md ? undefined : "0px"}
      withBreadcrumb
    >
      {width <= md && (
        <MobileMobileList
          data={data}
          isLoading={isLoading}
          systemSetting={systemSetting("mobility")}
          sort={sort}
          setSort={setSort}
          setRealMobFilter={setRealMobFilter}
          onClickBtn={onClickBtn}
          onClickMapIcon={onClickMapIcon}
          onClickTestMode={onClickTestMode}
          onClickDetailIcon={onClickIcon}
          onClickDeleteIcon={onClickTrashIcon}
        />
      )}
      {width > md && (
        <>
          <BodyHeader>
            <span style={{ marginRight: "5px" }}>{t.mobileList.searchedDevices} - </span>
            {isLoading && <DotLoader />}
            {!isLoading && data && <span>{data.total_items + " " + t.mobileList.unit}</span>}
            {!isLoading && !data && <span>{`0 ` + t.mobileList.unit}</span>}
          </BodyHeader>
          <TableHeader>
            {<MuiCheckbox
              checked={isAllCheck}
              onClick={() => {
                {
                  handleAllCheckClick();
                }
              }}
              sx={{
                padding: "5px",
              }}
            />}
            {makeTableHeadList("mobility_name", t.mobileList.deviceName, 210)}
            {/* {makeTableHeadList("mobility_name", "장비 모델명", 110)} */}
            {makeTableHeadList("mobility_type", t.mobileList.deviceType, 120)}
            {makeTableHeadList("name", t.mobileList.owner, 100)}
            {makeTableHeadList("status", t.mobileList.operationStatus, 85)}
            {makeTableHeadList("gps_date", t.mobileList.lastOperationDate, 120)}
            {/* {makeTableHeadList("device_pid", "단말기 시리얼 번호", 140)} */}
            {makeTableHeadList("device_pid", t.mobileList.terminalSN, 90)}
            {/* {makeTableHeadList(
              "board_input_volt",
              "농기계 배터리 전압",
              140
            )} */}
            {makeTableHeadList("board_input_volt", t.mobileList.machineryBattery, 80)}
            {/* {makeTableHeadList("backup_volt", "단말 배터리 상태", 125)} */}
            {makeTableHeadList("backup_volt", t.mobileList.terminalBattery, 80)}
            {makeTableHeadList("test_mode", t.mobileList.testMode, 62)}
          </TableHeader>
          <TableBody>
            {isLoading && <Spinner />}
            {data &&
              data.list.map((el, idx) => (
                <TableList key={el.seq}>
                  {/* 체크박스 */}
                  <MuiCheckbox
                    onChange={() => {
                      {
                        handleCheckClick(el.seq);
                      }
                    }}
                    checked={selectRow.split(',').map(item => item.trim()).some(item => item === el.seq.toString())}
                    //checked={selectRow.includes(el.seq.toString())}
                    //checked={selectedSeq.has(el.seq)}
                    sx={{
                      padding: "5px",
                    }}
                  />
                  {/* 기기명 */}
                  <CustomTooltip
                    title={el.mobility_name}
                    active={el.mobility_name.length > 16}
                  >
                    <MobInfo
                      style={{
                        textAlign: "center",
                        minWidth: "210px",
                        maxWidth: "210px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        onClickCopy(el.mobility_name);
                      }}
                    >
                      {textSubstring(el.mobility_name, 0, 20)}
                    </MobInfo>
                  </CustomTooltip>
                  {/* 기기 종류 */}
                  <CustomTooltip
                    title={el.mobility_type}
                    active={el.mobility_type.length > 8}
                  >
                    <MobInfo
                      style={{
                        minWidth: "120px",
                        textAlign: "center",
                      }}
                    >
                      {textSubstring(el.mobility_type, 0, 8)}
                    </MobInfo>
                  </CustomTooltip>
                  {/* 소유자 */}
                  <CustomTooltip
                    title={el.name}
                    active={el.name.length > 6}
                  >
                    <MobInfo
                      style={{
                        minWidth: "100px",
                        maxWidth: "100px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        onClickCopy(el.name);
                      }}
                    >
                      {textSubstring(el.name, 0, 6)}
                    </MobInfo>
                  </CustomTooltip>
                  {/* 운행 여부 */}
                  <MobInfo
                    style={{
                      minWidth: "85px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <StatusCircle
                      isLive={el.status === "운행중" ? true : false}
                    />
                    {el.status ?? t.control.notOperating}
                  </MobInfo>
                  {/* 최근 운행 일시 */}
                    <CustomTooltip
                    title={t.mobileList.inspectionNeeded}
                    active={isOlderThan24Hours(el.gps_date)}
                  >
                    <MobInfo
                      style={{
                        minWidth: "120px",
                        color: isOlderThan24Hours(el.gps_date)
                          ? theme.color.red_500
                          : theme.color.neutral_600,
                      }}
                    >
                      {!el.gps_date
                        ? t.mobileList.noRecord
                        : formatDate(el.gps_date, "yyyy-MM-dd HH:mm")}
                    </MobInfo>
                  </CustomTooltip>
                  {/* 단말기 시리얼 번호 */}
                  <MobInfo
                    style={{ minWidth: "90px", cursor: "pointer" }}
                    onClick={() => {
                      onClickCopy(el.device_pid);
                    }}
                  >
                    {el.device_pid}
                  </MobInfo>
                  {/* 농기계 배터리 전압 */}
                  <MobInfo
                    style={
                      Number(el.board_input_volt) < 12
                        ? {
                            minWidth: "80px",
                            color: "red",
                            cursor: "pointer",
                          }
                        : {
                            minWidth: "80px",
                            color: "black",
                          }
                    }
                  >
                    <BatteryImageContainer
                      input_volt={Number(el.board_input_volt)}
                    >
                      {`${el.board_input_volt} V`}
                      {Number(el.board_input_volt) < 12 && (
                        <BatteryImage
                          src={BattertyDescription}
                          alt="BatteryDescription"
                        />
                      )}
                    </BatteryImageContainer>
                  </MobInfo>
                  {/* 단말 배터리 상태 */}
                  <CustomTooltip title={el.backup_volt} active>
                    <MobInfo
                      style={{ minWidth: "80px" }}
                      id={`backupVoltToolTip-${idx}`}
                    >
                      {/* {el.backup_volt} */}
                      {Number(el.backup_volt) > 3.91 ? (
                        <Battery5 />
                      ) : Number(el.backup_volt) > 3.81 ? (
                        <Battery4 />
                      ) : Number(el.backup_volt) > 3.61 ? (
                        <Battery3 />
                      ) : Number(el.backup_volt) > 3.41 ? (
                        <Battery2 />
                      ) : Number(el.backup_volt) > 3.11 ? (
                        <Battery1 />
                      ) : (
                        <Battery0 />
                      )}
                    </MobInfo>
                  </CustomTooltip>

                  {/* 점검모드 */}
                  <SrLable
                    id={el.device_pid}
                    labelText={`${el.mobility_name} 점검모드 온오프 스위치`}
                  />
                  <Box
                    sx={{
                      "&:focus-within": {
                        outline: "2px solid black", // 포커스 시 테두리 색상
                      },
                    }}
                  >
                    <Switch
                      inputProps={{
                        "aria-labelledby": el.device_pid, // 외부 라벨과 연결
                      }}
                      id={el.device_pid}
                      checked={el.test_mode === 0 ? false : true}
                      onClick={() =>
                        onClickTestMode(el.device_pid, el.test_mode)
                      }
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault(); // 기본 동작 방지 (예: 스페이스 키 스크롤)
                          onClickTestMode(el.device_pid, el.test_mode); // 클릭 이벤트 트리거
                        }
                      }}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: theme.statusColor.MAIN,
                          "&:hover": {
                            backgroundColor: alpha(
                              theme.statusColor.MAIN,
                              0.3
                            ),
                          },
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: theme.statusColor.MAIN,
                          },
                      }}
                    />
                  </Box>

                  <IconBox>
                    {/* 기기정보 상세보기 아이콘 */}
                    <CustomTooltip title={t.mobileList.deviceDetail} active>
                      <IconWrapper
                        onClick={() => {
                          onClickIcon(el.seq);
                        }}
                      >
                        <GrayClassAndBoardIcon />
                      </IconWrapper>
                    </CustomTooltip>
                    {/* 지도에서 보기 아이콘 */}
                    <CustomTooltip title={t.mobileList.viewOnMap} active>
                      <IconWrapper onClick={() => onClickMapIcon(el)}>
                        <GrayMapIcon />
                      </IconWrapper>
                    </CustomTooltip>

                    {user?.grade === 2 && (
                      <CustomTooltip title={t.mobileList.deviceDelete} active>
                        <IconWrapper
                          onClick={() => {
                            if (!systemSetting("mobility")?.delete) return;
                            onClickTrashIcon(el);
                          }}
                          disabled={!systemSetting("mobility")?.delete}
                        >
                          <TrashCanIcon />
                        </IconWrapper>
                      </CustomTooltip>
                    )}
                  </IconBox>
                </TableList>
              ))}
            {!isLoading && data && data.list.length === 0 && (
              <NoDataMassage>{t.common.noData}</NoDataMassage>
            )}
          </TableBody>
        </>
      )}

      {!isLoading && (
        <PaginationFooter>
          {width > md && (
            <Button
              bgColor={theme.statusColor.MAIN}
              hoverColor={theme.color.green_600}
              width={"200px"}
              height={"40px"}
              paddingX="0px"
              onClick={onClickDown}
            >
              {`${selectCount}${t.mobileList.exportInstallHistory}`}
            </Button>
          )}

          <PaginationCenter>
            <Pagination
              count={data?.total_page}
              page={page + 1}
              siblingCount={width <= md ? 1 : 3}
              onChange={handleChange}
              size={width <= md ? "small" : "medium"}
            />
          </PaginationCenter>
        </PaginationFooter>
      )}

      {openModal && (
        <MobilityDetailModal
          open={openModal}
          seq={idx}
          onClickCancel={onClickCancel}
          onClose={onCloseDetailModal}
          systemSetting={systemSetting("mobility")}
        />
      )}

      {openDelModal && (
        <AlertModal
          open={openDelModal}
          onPressNo={onCancelDel}
          title={t.mobileList.deleteDevice}
          content={t.mobileList.deleteDeviceContent}
          confirmText={t.mobileList.confirmDelete}
          onPressYes={onClickDel}
          icon={<WarningIcon />}
        />
      )}

      {openToggleModal && (
        <AlertModal
          open={openToggleModal}
          onPressNo={onCancelToggle}
          title={
            testMode
              ? t.mobileList.testModeDeactivate
              : t.mobileList.testModeActivate
          }
          content={
            testMode
              ? t.mobileList.testModeDeactivateContent
              : t.mobileList.testModeActivateContent
          }
          confirmText={testMode ? t.common.no : t.common.yes}
          onPressYes={onClickToggle}
          icon={<WarningIcon />}
        />
      )}
    </PageLayout>
  );
};

const BodyHeader = styled.h1`
  font-weight: 700;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.color.neutral_600};
  padding-bottom: 15px;
  border-bottom: 3px solid ${theme.color.neutral_200};
  display: flex;
  align-items: center;
`;

const TableHeader = styled.div`
  margin-top: 15px;
  margin-bottom: 10px;
  display: flex;
  gap: 15px;
  padding-left: 20px;
  padding-right: 20px;
`;

const TableHeaderList = styled.button<{ width: number }>`
  min-width: ${({ width }) => `${width}px`};
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  white-space: pre-line; /* \n 개행 허용 */
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${theme.color.neutral_500};
  cursor: pointer;
  transition: 200ms;
  &:hover {
    font-weight: bold;
  }
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  background-color: transparent;
`;

const TableBody = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`;

const TableList = styled.div`
  background: ${theme.color.white};
  border-radius: 10px;
  /* min-width: 100%; */
  height: 46px;
  display: flex;
  gap: 15px;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
`;

const PaginationFooter = styled.footer`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 12px;
  margin-top: 30px;
  padding: 0 20px;

  @media (max-width: ${md}px) {
    height: 56px;
    margin-top: 0px;
    align-items: center;
    gap: 0px;

    nav {
      padding: 14px 0px;
    }

    button {
      min-width: 28px;
      height: 28px;
      font-size: ${theme.fontSize.FONT_1};
      font-weight: ${theme.fontWeight.SEMI_BOLD};
      color: ${theme.color.neutral_500};
    }
  }
`;

const PaginationCenter = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
`;

const MobInfo = styled.span`
  display: block;
  font-weight: 500;
  font-size: 13px;
  line-height: 15px;
  color: ${theme.color.neutral_600};
  text-align: center;
  // 추가
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const IconBox = styled.div`
  display: flex;
  gap: 15px;
  flex: 1;
  justify-content: flex-end;
`;

const IconWrapper = styled.button<{ disabled?: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  background: ${theme.color.neutral_200};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${({ disabled }) => (disabled ? "defalut" : "pointer")};
  transition: 200ms;
  &:hover {
    scale: ${({ disabled }) => (disabled ? "100%" : "120%")};
  }
`;

const StatusCircle = styled.span<{ isLive: boolean }>`
  display: block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: ${({ isLive }) =>
    isLive ? `${theme.color.green_500}` : `${theme.color.neutral_400}`};
  margin-right: 5px;
`;

const BatteryImageContainer = styled.div<{ input_volt: number }>`
  ${({ input_volt }) =>
    input_volt < 12
      ? "&:hover {img {display: block;}}"
      : "img {display: none;}"}
  img {
    display: none;
  }
`;
const BatteryImage = styled.img`
  position: absolute;
  top: 20%;
  left: 20%;
  width: 40%;
  z-index: 10;
`;

const NoDataMassage = styled.div`
  text-align: center;
  padding: 100px;
  color: ${theme.color.neutral_500};
`;

export default MobileList;
